(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-hatchill-app-conversion]';
  var ENGAGEMENT_PAGE_TYPES = ['index', 'collection'];
  var DISMISSED_AT_KEY = 'hatchill_app_conversion_closed_at';
  var STORE_CLICKED_AT_KEY = 'hatchill_app_conversion_store_clicked_at';
  var LEGACY_CLICKED_AT_KEY = 'hatchill_app_conversion_clicked_at';
  var SEEN_THIS_SESSION_KEY = 'hatchill_app_conversion_seen';
  var STORE_CLICK_COOLDOWN_MS = 30 * 24 * 60 * 60 * 1000;

  function initAll(scope) {
    var context = scope || document;
    var roots = [];

    if (context.matches && context.matches(ROOT_SELECTOR)) roots.push(context);
    if (context.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(context.querySelectorAll(ROOT_SELECTOR)));
    }

    roots.forEach(init);
  }

  function init(root) {
    if (!root || root.dataset.hatchillAppInitialized === 'true') return;
    root.dataset.hatchillAppInitialized = 'true';

    var modal = root.querySelector('[data-hatchill-app-modal]');
    if (!modal) return;

    var pageType = root.dataset.pageType || '';
    var path = window.location.pathname || '';
    if (pageType === 'cart' || /^\/(cart|checkout)(\/|$)/.test(path)) return;
    if (ENGAGEMENT_PAGE_TYPES.indexOf(pageType) === -1) return;
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return;

    var userAgent = navigator.userAgent || '';
    var isAndroid = /android/i.test(userAgent);
    var isIos = /iPad|iPhone|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);
    var mobilePlatform = isIos ? 'ios' : isAndroid ? 'android' : 'web';
    var mobileLink = isIos ? root.dataset.iosLink : root.dataset.androidLink;
    var mobileCta = root.querySelector('[data-hatchill-app-mobile-link]');
    var modalDelayMs = Number(root.dataset.modalDelayMs || 18000);
    var dismissalCooldownMs = Number(root.dataset.dismissalCooldownMs || 86400000);
    var creativeVersion = root.dataset.creativeVersion || 'app-popup-app10-v1';
    var offerCode = root.dataset.offerCode || 'APP10';
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delayElapsed = false;
    var engagementMet = ENGAGEMENT_PAGE_TYPES.indexOf(pageType) === -1;
    var modalShown = false;
    var modalHasBeenShown = false;
    var previouslyFocused = null;
    var lastInteractionAt = 0;
    var currentTrigger = 'delay_engagement';
    var retryTimer = null;
    var delayTimer = null;
    var iconWarmTimer = null;
    var closeTimer = null;
    var inertedElements = [];
    var cartObserver = null;

    if (mobileCta && mobileLink) {
      mobileCta.href = mobileLink;
      mobileCta.dataset.platform = mobilePlatform;
    }
    if (mobilePlatform === 'web') root.classList.add('hatchill-app-conversion--desktop-links');

    function getStorage() {
      try {
        var testKey = '__hatchill_app_storage__';
        window.localStorage.setItem(testKey, '1');
        window.localStorage.removeItem(testKey);
        return window.localStorage;
      } catch (error) {
        try {
          return window.sessionStorage;
        } catch (sessionError) {
          return null;
        }
      }
    }

    var storage = getStorage();

    function storageGet(key) {
      if (!storage) return null;
      try {
        return storage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function storageSet(key, value) {
      if (!storage) return;
      try {
        storage.setItem(key, value);
      } catch (error) {
        return;
      }
    }

    function sessionGet(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function sessionSet(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        return;
      }
    }

    function timestampIsRecent(key, cooldownMs) {
      var value = Number(storageGet(key) || 0);
      return value > 0 && Date.now() - value < cooldownMs;
    }

    function isInCooldown() {
      return timestampIsRecent(DISMISSED_AT_KEY, dismissalCooldownMs)
        || timestampIsRecent(STORE_CLICKED_AT_KEY, STORE_CLICK_COOLDOWN_MS)
        || timestampIsRecent(LEGACY_CLICKED_AT_KEY, STORE_CLICK_COOLDOWN_MS);
    }

    function placement() {
      return window.matchMedia('(max-width: 767px)').matches ? 'mobile_sheet' : 'desktop_modal';
    }

    function track(name, properties) {
      var payload = {
        location: 'app_conversion_popup',
        placement: placement(),
        page_type: pageType,
        platform: properties && properties.platform ? properties.platform : mobilePlatform,
        trigger: properties && properties.trigger ? properties.trigger : currentTrigger,
        creative_version: creativeVersion,
        offer_code: offerCode
      };

      if (properties) {
        Object.keys(properties).forEach(function (key) {
          if (key !== 'platform' && key !== 'trigger') payload[key] = properties[key];
        });
      }

      if (window.HatchillEvents && window.HatchillEvents.track) {
        window.HatchillEvents.track(name, payload);
      }

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var published = window.Shopify.analytics.publish('hatchill:' + name, payload);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      }
    }

    function cartDrawerIsOpen() {
      return !!document.querySelector('cart-drawer.open, cart-drawer.active, #Cart-Drawer.open, #Cart-Drawer.active');
    }

    function userIsTyping() {
      var active = document.activeElement;
      if (!active) return false;
      return /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName) || active.isContentEditable;
    }

    function anotherDialogIsOpen() {
      var dialogs = document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])');
      return Array.prototype.some.call(dialogs, function (dialog) {
        if (root.contains(dialog)) return false;
        var styles = window.getComputedStyle(dialog);
        var rect = dialog.getBoundingClientRect();
        return rect.width > 0
          && rect.height > 0
          && styles.display !== 'none'
          && styles.visibility !== 'hidden'
          && Number(styles.opacity || 1) > 0;
      });
    }

    function collectionFilterDrawerIsOpen() {
      return Boolean(document.querySelector('.mobile-facets__disclosure[open]'));
    }

    function suppressionReason(force) {
      if (document.visibilityState === 'hidden') return 'hidden_page';
      if (cartDrawerIsOpen()) return 'cart_drawer';
      if (collectionFilterDrawerIsOpen()) return 'filter_drawer';
      if (anotherDialogIsOpen()) return 'other_dialog';
      if (userIsTyping()) return 'typing';
      if (!force && lastInteractionAt && Date.now() - lastInteractionAt < 2500) return 'recent_activity';
      return '';
    }

    function getFocusableElements() {
      return Array.prototype.slice.call(
        modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true';
      });
    }

    function setPageInert(shouldInert) {
      if (!document.body || !('inert' in document.body)) return;

      if (!shouldInert) {
        inertedElements.forEach(function (element) {
          element.inert = false;
        });
        inertedElements = [];
        return;
      }

      Array.prototype.forEach.call(document.body.children, function (element) {
        if (element.contains(root) || element.inert || /^(SCRIPT|STYLE|LINK)$/.test(element.tagName)) return;
        element.inert = true;
        inertedElements.push(element);
      });
    }

    function handleModalKeydown(event) {
      if (!modalShown || modal.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(true);
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = getFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        modal.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function focusModal() {
      if (modal.hidden) return;
      var closeButton = modal.querySelector('.hatchill-app-modal__close');
      (closeButton || modal).focus({ preventScroll: true });
    }

    function scheduleRetry() {
      window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(function () {
        showModal(false, 'delay_engagement');
      }, 2700);
    }

    function showModal(force, trigger) {
      if (modalShown || modal.classList.contains('is-closing') || isInCooldown()) return;
      if (force !== true && (modalHasBeenShown || sessionGet(SEEN_THIS_SESSION_KEY) === '1')) return;
      if (force !== true && (!delayElapsed || !engagementMet)) return;

      var reason = suppressionReason(force === true);
      if (reason) {
        if (
          reason === 'recent_activity'
          || reason === 'typing'
          || reason === 'hidden_page'
          || reason === 'cart_drawer'
          || reason === 'filter_drawer'
          || reason === 'other_dialog'
        ) scheduleRetry();
        return;
      }

      currentTrigger = trigger || 'delay_engagement';
      modalShown = true;
      modalHasBeenShown = true;
      sessionSet(SEEN_THIS_SESSION_KEY, '1');
      previouslyFocused = document.activeElement;
      modal.hidden = false;
      modal.classList.remove('is-closing');
      document.documentElement.classList.add('has-hatchill-app-modal');
      setPageInert(true);
      document.addEventListener('keydown', handleModalKeydown);
      document.dispatchEvent(new CustomEvent('hatchill-app-modal:open'));

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          modal.classList.add('is-visible');
        });
      });

      window.setTimeout(focusModal, prefersReducedMotion ? 0 : 80);
      track('app_offer_viewed', { trigger: currentTrigger });
      track('app_modal_shown', { trigger: currentTrigger });
    }

    function closeModal(recordDismissal) {
      if ((!modalShown && modal.hidden) || modal.classList.contains('is-closing')) return;
      modalShown = false;
      modal.classList.remove('is-visible');
      modal.classList.add('is-closing');
      document.removeEventListener('keydown', handleModalKeydown);

      if (recordDismissal !== false) {
        storageSet(DISMISSED_AT_KEY, String(Date.now()));
        track('app_modal_dismissed');
      }

      function finishClose() {
        modal.hidden = true;
        modal.classList.remove('is-closing');
        document.documentElement.classList.remove('has-hatchill-app-modal');
        setPageInert(false);
        document.dispatchEvent(new CustomEvent('hatchill-app-modal:close'));

        if (!cartDrawerIsOpen() && previouslyFocused && document.documentElement.contains(previouslyFocused)) {
          previouslyFocused.focus({ preventScroll: true });
        }
        previouslyFocused = null;
      }

      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(finishClose, prefersReducedMotion ? 0 : 240);
    }

    function updateEngagement() {
      if (engagementMet) return;
      var documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      var scrollableDistance = Math.max(0, documentHeight - window.innerHeight);
      if (scrollableDistance === 0 || window.scrollY / scrollableDistance >= 0.18) {
        engagementMet = true;
        window.removeEventListener('scroll', updateEngagement);
        showModal(false, 'delay_engagement');
      }
    }

    function noteInteraction() {
      lastInteractionAt = Date.now();
    }

    function handleRequestOpen() {
      delayElapsed = true;
      engagementMet = true;
      showModal(true, 'manual');
    }

    function syncWithCartDrawer() {
      if (cartDrawerIsOpen()) {
        if (modalShown) closeModal(false);
        return;
      }
      showModal(false, 'delay_engagement');
    }

    root.querySelectorAll('[data-hatchill-app-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeModal(true);
      });
    });

    root.querySelectorAll('[data-hatchill-app-store-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        var platform = link.dataset.platform || mobilePlatform;
        var destination = link.dataset.destination || 'smart_download';
        storageSet(STORE_CLICKED_AT_KEY, String(Date.now()));
        track('app_offer_clicked', { platform: platform, destination: destination });
        track('app_cta_tapped', { platform: platform, destination: destination });
      });
    });

    document.addEventListener('pointerdown', noteInteraction, { passive: true });
    document.addEventListener('keydown', noteInteraction);
    document.addEventListener('hatchill-app-modal:request-open', handleRequestOpen);
    document.addEventListener('cart-drawer:open', syncWithCartDrawer);
    document.addEventListener('cart-drawer:close', syncWithCartDrawer);

    var cartDrawer = document.querySelector('cart-drawer, #Cart-Drawer');
    if (cartDrawer && window.MutationObserver) {
      cartObserver = new MutationObserver(syncWithCartDrawer);
      cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    if (!engagementMet) {
      window.addEventListener('scroll', updateEngagement, { passive: true });
      updateEngagement();
    }

    var icon = root.querySelector('.hatchill-app-modal__app-icon img');
    if (icon) {
      iconWarmTimer = window.setTimeout(function () {
        icon.loading = 'eager';
        if (icon.decode) icon.decode().catch(function () {});
      }, Math.min(6000, Math.max(1000, Math.round(modalDelayMs / 2))));
    }

    delayTimer = window.setTimeout(function () {
      delayElapsed = true;
      showModal(false, 'delay_engagement');
    }, modalDelayMs);

    root.hatchillAppCleanup = function () {
      window.clearTimeout(retryTimer);
      window.clearTimeout(delayTimer);
      window.clearTimeout(iconWarmTimer);
      window.clearTimeout(closeTimer);
      window.removeEventListener('scroll', updateEngagement);
      document.removeEventListener('pointerdown', noteInteraction);
      document.removeEventListener('keydown', noteInteraction);
      document.removeEventListener('keydown', handleModalKeydown);
      document.removeEventListener('hatchill-app-modal:request-open', handleRequestOpen);
      document.removeEventListener('cart-drawer:open', syncWithCartDrawer);
      document.removeEventListener('cart-drawer:close', syncWithCartDrawer);
      if (cartObserver) cartObserver.disconnect();
      if (modalShown) closeModal(false);
    };
  }

  function handleSectionLoad(event) {
    initAll(event.target);
  }

  function handleSectionUnload(event) {
    var root = event.target.querySelector && event.target.querySelector(ROOT_SELECTOR);
    if (root && root.hatchillAppCleanup) root.hatchillAppCleanup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
})();
